import { render, staticRenderFns } from "./dateblock.vue?vue&type=template&id=259131b6&"
import script from "./dateblock.vue?vue&type=script&lang=js&"
export * from "./dateblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports